import { useCallback } from 'react';
import { useAuthContext } from 'modules/auth/context';

/**
 * Pushes a balance the server reported into the auth user. The profile query
 * never re-writes the user after the first load, so purchases and top-ups
 * would otherwise leave a stale balance on screen.
 */
export function useSetBalance(): (balanceSom: unknown) => void {
  const { methods } = useAuthContext();
  return useCallback(
    (balanceSom: unknown) => {
      if (typeof balanceSom !== 'number' || !Number.isFinite(balanceSom)) return;
      methods.setUser((user) => (user ? { ...user, balanceSom } : user));
    },
    [methods],
  );
}
